import jQuery from 'jquery';
import '@lottiefiles/lottie-player';

jQuery(($) => {});
